import type Quill from 'quill/core';

const listenBody = <K extends keyof HTMLElementEventMap>(
  event: K,
  handler: (event: HTMLElementEventMap[K]) => void,
  quill: Quill,
) => {
  const listener: typeof handler = (e) => {
    if (!document.body.contains(quill.root)) {
      document.body.removeEventListener(event, listener);
      return;
    }
    handler(e);
  };
  document.body.addEventListener(event, listener);
};

export default listenBody;
